export default __webpack_public_path__ + "static/experiment-setup-dark-7ec64cf03df4f34154cc808fc6bfc102.png";